import { useRecoilValue } from "recoil";
import { authorizationQuery } from "./store/AuthorizationState";
import { setCustomerSettings } from "./CustomerSettings";
import { userState } from "./store/UserState";

let customer;
let cycleDate;
function Authorization({children}) {
  const user = useRecoilValue(userState);
  const authorization = useRecoilValue(authorizationQuery(user.customer));

  setCustomerSettings(authorization);
  customer = user.customer;
  cycleDate = authorization.cycleDate;

  return (
    children
  );
}

export default Authorization;

export const getCustomer = () => {
  return customer;
}

export const getCycleDate = () => {
  return cycleDate;
}